<section class="sh-dialog__content -sh-overflow-scrolling">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</section>

<ng-template #content>
  <div class="sh-card-table-wrapper">
    <table class="sh-card-table">
      <thead>
        <tr>
          <th scope="col" class="sh-card-table__col">{{ 'batches.error-dialog.id' | translate }}</th>
          @if (viewMonitor) {
            <th scope="col" class="sh-card-table__col">{{ 'batches.error-dialog.error' | translate }}</th>
          }
          <th scope="col" class="sh-card-table__col">{{ 'batches.error-dialog.info' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @if (mailToServices$ | async; as mailTo) {
          <ng-container>
            <tr>
              <td>{{ batch.Id }}</td>
              <td class="sh-preserve-linebreaks sh-wrap-text">{{errorMessage}}</td>
              @if (viewMonitor) {
                <td class="sh-preserve-linebreaks sh-wrap-text">
                  <a [href]="detailUrl">{{'batches.error-dialog.monitoring' | translate}}</a>
                </td>
              }
              @if (actionItem$ | async; as group) {
                <td class="sh-card-table__col--small">
                  <sh-action-group [actionGroup]="group"></sh-action-group>
                </td>
              }
            </tr>
          </ng-container>
        }
      </tbody>
    </table>
  </div>
</ng-template>
